import React, { Component } from "react";
import {
  Grid,
  RadioGroup,
  FormLabel,
  FormControlLabel,
  Radio,
  Link,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import "date-fns";
import "fontsource-roboto";

require("../assets/css/style.css");
require("../assets/css/all-style.css");

const useStyles = {
  root: {
    "& > *": {
      width: "65ch",
    },
  },
  inputText: {
    padding: "0 5px 0 0",
  },
  breakLine: {
    margin: "20px 0 0 0",
  },
  breakLineInset: {
    margin: "20px 0 0 16px",
  },
};

class SearchTool extends Component {
  constructor() {
    super();
    this.state = {
      searchToolTop: "0",
    };
  }

  clickSearchTool = (isClose) => {
    this.setState({
      searchToolTop: isClose ? "-42px" : "0",
    });
  };

  render() {
    const {
      order,
      totalCount,
      handleOrder,
      showLoading,
      nojc,
      originalKeyword,
      correctedKeyword,
      handleJiuCuo,
      isGh,
    } = this.props;

    return (
      <Grid>
        <div className="search_tool_outer search_tool_relative">
          <div className="search_tool_wrapper">
            <div
              style={{ top: this.state.searchToolTop }}
              className="search_tool_inner search_tool_relative"
            >
              <div className="search_tool_options">
                <div
                  className="search_tool search_tool_pointer search_tool_hover"
                  onClick={this.clickSearchTool.bind(this, true)}
                >
                  <i className="c-icon search_tool_hover icons_filter"></i>
                  搜索工具
                </div>
                <span className="search_tool_hint c_font_2AD7M">
                  为您找到相关结果约{totalCount}个
                </span>
              </div>
              <div className="search_tool_options">
                <span className="search_tool_close_wrapper">
                  <span
                    className="search_tool_pointer search_tool_hover"
                    onClick={this.clickSearchTool.bind(this, false)}
                  >
                    <i className="c-icon search_tool_hover icons_expandless"></i>
                    收起工具
                  </span>
                </span>
                <span className="search_tool_pointer">
                  <RadioGroup
                    row
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="radio-group"
                    value={order}
                    onChange={handleOrder.bind(this)}
                  >
                    <FormLabel
                      classes={{
                        root: "custom_form_label_root",
                      }}
                    >
                      排序方式：
                    </FormLabel>
                    <FormControlLabel
                      value="1"
                      control={<Radio size="small" color="primary" />}
                      label="相关度"
                      classes={{
                        root: "custom_form_label_root",
                      }}
                    />
                    <FormControlLabel
                      value="2"
                      control={<Radio size="small" color="primary" />}
                      label="时间"
                      classes={{
                        root: "custom_form_label_root",
                      }}
                    />
                    <FormControlLabel
                      value="3"
                      control={<Radio size="small" color="primary" />}
                      label="综合"
                      classes={{
                        root: "custom_form_label_root",
                      }}
                    />
                  </RadioGroup>
                </span>
              </div>
            </div>
          </div>
        </div>
        {!showLoading && !nojc && originalKeyword !== correctedKeyword ? (
          <div className="search_tool_correct search_tool_relative">
            <div>
              已显示&nbsp;
              <span className="c-color-text">"{correctedKeyword}"</span>
              &nbsp;的搜索结果。仍然搜索：
              <Link
                className="search-keyword-nojc"
                component="a"
                onClick={() => handleJiuCuo(this)}
                variant="body1"
                dangerouslySetInnerHTML={{
                  __html: originalKeyword,
                }}
              ></Link>
            </div>
          </div>
        ) : (
          ""
        )}
      </Grid>
    );
  }
}

export default withStyles(useStyles)(SearchTool);
